export const formatPhone = (phone: string): string => {
  if (phone.length !== 10) {
    return phone;
  }

  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
};
